<!-- DELEGATOR -->
<div class='node-delegator'>
    @switch (stepInfo.type) {
        @case ('action') {
            <ng-container *ngTemplateOutlet="action"></ng-container>
        }
        @case ('menu') {
            <ng-container *ngTemplateOutlet="menu"></ng-container>
        }
        @case ('integration') {
            <ng-container *ngTemplateOutlet="integration"></ng-container>
        }
        @case ('start') {
            <ng-container *ngTemplateOutlet="jsonToForm"></ng-container>
        }
    }
</div>

<!-- ACTIONS -->
<ng-template #action>
    <div class='node-delegator-nodes'>
        @switch (nodeType) {
            @case ('waitForCallback') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-wait-for-callback #node></app-wait-for-callback>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('setVariable') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-variable-node #node></app-variable-node>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('sendTemplate') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-send-template #node></app-send-template>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('chatHub') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <chat-hub #node [stepId]="stepId"></chat-hub>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('switchCase') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-switch-case #node></app-switch-case>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('decimalFormat') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-decimal-format #node></app-decimal-format>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('httpCall') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-http-call #node></app-http-call>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('regularExpression') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-regular-expression #node></app-regular-expression>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('encrypt') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-encrypt #node></app-encrypt>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('isEmpty') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-is-empty #node></app-is-empty>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('isNull') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-is-null #node></app-is-null>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('math') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-math #node></app-math>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('redis') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-redis #node></app-redis>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('dateFormat') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-date-format #node></app-date-format>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('remap') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-remap #node></app-remap>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('displayList') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-display-list #node></app-display-list>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('switchCase') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-switch-case #node></app-switch-case>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('decimalFormat') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-decimal-format #node></app-decimal-format>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('httpCall') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-http-call #node></app-http-call>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('redis') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-redis #node></app-redis>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('optOut') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-opt-out #node></app-opt-out>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('deleteOptOut') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-delete-opt-out #node></app-delete-opt-out>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('verifyOptOut') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-verify-opt-out #node></app-verify-opt-out>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('customTransform') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-custom-transform #node></app-custom-transform>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
                  @case ('sendRichText') {
        <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
        <app-send-rich-text #node></app-send-rich-text>
        <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
      }
      @case ('contactBook') {
        <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
        <app-contact-book #node></app-contact-book>
        <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
      }
      @default {
                <ng-container [ngTemplateOutlet]="jsonToForm"></ng-container>
            }
        }
    </div>
</ng-template>

<!-- MENUS -->
<ng-template #menu>
    <div class='node-delegator-nodes'>
        @switch (nodeType) {
            @case ('contactReceiving') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-contact-recieving #node></app-contact-recieving>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('contactSending') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-contact-sending #node></app-contact-sending>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('multipleChoice') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-multiple-choice #node></app-multiple-choice>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('multiProduct') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <multi-product #node></multi-product>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('dynamicList') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-dynamic-list #node></app-dynamic-list>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('menuForm') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <menu-form #node></menu-form>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('chat2pay') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-chat2pay #node></app-chat2pay>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('location') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-location-node #node></app-location-node>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('media') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-media #node></app-media>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('aiAssistant') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-ai-assistant #node></app-ai-assistant>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('askInput') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-ask-input #node></app-ask-input>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('displayMenu') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-display-menu #node></app-display-menu>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('iMessage') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-imessage #node></app-imessage>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('otp') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-otp #node></app-otp>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('chatdesk') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-chatdesk #node></app-chatdesk>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('chatHubIntegration') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-chathub-integration #node></app-chathub-integration>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('externalLink') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-external-link #node></app-external-link>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('richLink') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <app-rich-link #node></app-rich-link>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @default {
                <ng-container [ngTemplateOutlet]="jsonToForm"></ng-container>
            }
        }
    </div>
</ng-template>

<ng-template #integration>
    <div class='node-delegator-nodes'>
        @switch (nodeType) {
            @case ('endFlow') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <end-flow #node></end-flow>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            @case ('async_api') {
                <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>
                <async-api #node></async-api>
                <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>
            }
            <!--    <ng-container *ngSwitchCase="'api'">-->
                    <!--      <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>-->
                    <!--      <app-api-end-node #node></app-api-end-node>-->
                    <!--      <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>-->
                    <!--    </ng-container>-->
                    <!--    <ng-container *ngSwitchCase="'nested'">-->
                    <!--      <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>-->
                    <!--      <app-nested-end-node #node></app-nested-end-node>-->
                    <!--      <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>-->
                    <!--    </ng-container>-->
                    <!--    <ng-container *ngSwitchCase="'nestedNode'">-->
                    <!--      <ng-container [ngTemplateOutlet]="nodeHeader"></ng-container>-->
                    <!--      <app-nested-node #node></app-nested-node>-->
                    <!--      <ng-container [ngTemplateOutlet]="nodeFooter"></ng-container>-->
                    <!--    </ng-container>-->
            @default {
                <ng-container [ngTemplateOutlet]="jsonToForm"></ng-container>
            }
        }
    </div>
</ng-template>

<!-- LEGACY -->
<ng-template #jsonToForm>
    @if (currentSelectedStep; as stepJson) {
        <json-to-from [stepTitle]="stepId" [typeName]="nodeType" [stepJson]="stepJson"
                      [isRecycleBinItem]="isRecycleBin" (saveNode)="saveNodeClicked($event)"
                      (deleteNode)="deleteNodeClicked($event)" (resetSelectedNode)="resetNode.emit()"
                      [isFlowLocked]="isFlowLocked"
                      [supportedChannel]="currentNodeType.supported_channel"></json-to-from>
    }
</ng-template>


<!-- NODE HEADER -->
<ng-template #nodeHeader>
    <div class="nodeHeader">
        <div class="nodeHeader-stepType">
            @switch (stepInfo.type) {
                @case ('menu') {
                    <ng-container [ngTemplateOutlet]="menuTitle"></ng-container>
                }
                @case ('action') {
                    <ng-container [ngTemplateOutlet]="actionTitle"></ng-container>
                }
                @case ('integration') {
                    <ng-container [ngTemplateOutlet]="interactionTitle"></ng-container>
                }
            }
        </div>
        <div class="node-number-container">
            <p class="number-text">
                {{ stepNumber }}
            </p>
        </div>
    </div>
</ng-template>

<ng-template #nodeFooter>
    <app-analytics-settings
            [stepAnalyticsSettings]="settingsData"
            (updateSettings)="updateAnalyticsSettings($event)"
            (close)="closeOverlay(overlayType.ANALYTICS)"
            [isDisabled]="!canEdit.canEditFlows"
            #analyticsSettings>Settings
    </app-analytics-settings>
    @if (currentNodeType.supported_channel === 'whatsapp' || currentNodeType.supported_channel === 'all') {
        <app-whats-app-settings
                [step]="stepInfo.step"
                (close)="closeOverlay(overlayType.WHATSAPP)"
                (update)="updateWaSettings($event)"
                [isDisabled]="canEdit.canEditFlows"
                #whatsAppSettings>Settings
        </app-whats-app-settings>
    }
    @if (isOpen === false) {
        <div class="nodeFooterHolder">
            <div class="nodeHeader-button">
                <button [disabled]="canSave" class="delete-btn" matTooltipClass="matTooltip" matTooltip="Delete node"
                        matTooltipPosition="above" (click)="openDeleteParentNodeDialog()"></button>
                <div class="track-btn" matTooltipClass="matTooltip" matTooltip="Track node" matTooltipPosition="above"
                     (click)="openOverlay(overlayType.ANALYTICS)"></div>
                @if (currentNodeType.supported_channel === 'whatsapp' || currentNodeType.supported_channel === 'all') {
                    <div
                            class="wa-btn" matTooltipClass="matTooltip" matTooltip="WhatsApp settings"
                            matTooltipPosition="above"
                            (click)="openOverlay(overlayType.WHATSAPP)"></div>
                }
                <div class="btn close-btn" [ngClass]="{'right-margin': isCurrentEnvProd}" id="resetNode"
                     (click)="resetNode.emit()">Close
                </div>
                <button [disabled]="canSave" class="btn save-btn" id="saveNode" (click)="saveNodeClicked()">Save
                </button>
            </div>
        </div>
    }
</ng-template>

<ng-template #icons>
    <div class="nodeTypeImage">
        @switch (nodeType) {
            @case ('chatHub') {
                <div class="node-icon"
                     [ngStyle]="{'background': 'url(' + stepInfo.extraFields['imageUrl'] + ') no-repeat center/100%, url(../../../../../assets/svg/redesign/nodes/right-panel/chatHub_rsb_fallback.svg) no-repeat center/100%', 'background-size': '26px auto'}">
                </div>
            }
            @default {
                <div class="node-icon"
                     [ngStyle]="{'background': 'url(' + currentNodeType?.image.primary + ') no-repeat center/100%'}">
                </div>
            }
        }
    </div>
</ng-template>

<ng-template #menuTitle>
    <div class="menu-title-container">
        <ng-container
                *ngTemplateOutlet="icons">
        </ng-container>
        <div class="title-container">
            <span class="nodeTypeName">{{ nodeTitle }}</span>
            <span class="nodeTypeDescription"> User-Facing Nodes </span>
        </div>
    </div>
</ng-template>

<ng-template #actionTitle>
    <div class="menu-title-container">
        <ng-container
                *ngTemplateOutlet="icons">
        </ng-container>
        <div class="title-container">
            <span class="nodeTypeName">{{ nodeTitle }}</span>
            <span class="nodeTypeDescription"> {{ nodeType === 'chatHub' ? 'Chat Hub Conversation' : 'Action' }} </span>
        </div>
    </div>
</ng-template>

<ng-template #interactionTitle>
    <div class="menu-title-container">
        <ng-container
                *ngTemplateOutlet="icons">
        </ng-container>
        <div class="title-container">
            <span class="nodeTypeName">{{ nodeTitle }}</span>
            <span class="nodeTypeDescription"> Integration </span>
        </div>
    </div>
</ng-template>

<!-- DELETE DIALOG -->
<ng-template #deleteParentNodeDialog>
    <div class="delete_parentNode_dialog">
        <div class="delete_parentNode_dialog_header">
            <label class="delete_parentNode_dialog_title">Deleting parent node</label>
            <button class="delete_parentNode_dialog_closeBtn" (click)="dialog.closeAll()">
                <img src='../../../../../assets/svg/close.svg'/>
            </button>
        </div>
        <div class="delete_parentNode_dialog_body">
            <div>
                This is a parent node. Deleting this parent node will also delete all
                <label class="delete_parentNode_dialog_childNode">{{ childCount }}</label> child nodes.
                <div class="delete_parentNode_dialog_checkBoxMessage">
                    Do you want to proceed with deleting?
                </div>
            </div>
            <div class="delete_parentNode_dialog_checkBox">
                <mat-checkbox id="check" class="parentCheckBox" (change)="setDisplay($event)">
          <span class="delete_parentNode_dialog_checkBox_label"
          >Don't show this message again.</span
          >
                </mat-checkbox>
            </div>
        </div>
        <div class="delete_parentNode_dialog_buttonsContainer">
            <button class="delete_parentNode_dialog_exitBtn" (click)="dialog.closeAll()">Cancel</button>
            <button class="delete_parentNode_dialog_deleteBtn" (click)="deleteNodeClicked(stepId)">
                Delete
            </button>
        </div>
    </div>
</ng-template>
